import { combineReducers } from 'redux'

import camerasReducer from './cameras'
import dashboardReducer from './dashboard'
import geoSectionsReducer from './geoSections'
import geoCategoriesReducer from './geoCategories'
import geoObjectsReducer from './geoObjects'


export default combineReducers({
  cameras: camerasReducer,
  dashboard: dashboardReducer,
  geoSections: geoSectionsReducer,
  geoCategories: geoCategoriesReducer,
  geoObjects: geoObjectsReducer,
})
